import { COLORS } from './constants/colors';

export const getTheme = () => ({
  token: {
    colorPrimary: COLORS.$primaryBlue,
    fontSize: 16,
    lineHeight: 1.5,
    fontSizeHeading2: 32,
    fontSizeHeading3: 24,
    fontSizeHeading4: 18,
    fontWeightStrong: 600,
  },
  components: {
    Button: {
      colorPrimary: COLORS.$primaryBlue,
      colorPrimaryHover: COLORS.$primaryBlueDark,
      colorPrimaryActive: COLORS.$primaryBlueDark,
    },
    Menu: {
      itemSelectedColor: COLORS.$primaryBlue,
      itemHoverColor: COLORS.$primaryBlue,
    },
  },
});

export const theme = {
  colors: COLORS,
  primaryColor: COLORS.$primaryBlue,
  accentColor: COLORS.$accentGreen,
};


